export const iconNames = [
  'ar-hand',
  'arrow-up-circle',
  'cert-on-inverted',
  'chevron-right',
  'checkmark',
  'globe',
  'growth',
  'legal',
  'lightbulb',
  'mobile',
  'money',
  'parcel',
  'person-pin',
  'protection',
  'recurring-arrow',
  'smiley',
  'transparency',
  'user',
  'watch',
  'watches',
  'watch-chart',
  'watch-filled',
  'worldwide',

  'chrono24',
  'facebook',
  'instagram',
  'linkedin',
  'xing',
  'youtube',

  'arrow-up-right',
  'play',
  'times',
] as const;

function SvgWrapper({
  children,
  className = undefined,
  viewBox,
}: {
  children: React.ReactNode;
  className?: string;
  viewBox: string;
}) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      fill="currentColor"
      focusable="false"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export default function Icon({
  className = undefined,
  name,
}: {
  /** Additional CSS class(es) for the icon */
  className?: string;
  /** Name / identifier of the icon */
  name: (typeof iconNames)[number];
}) {
  /* Brand icons */

  if (name === 'ar-hand') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M19.22,6.29c-.19-.8-.89-1.36-1.71-1.36h-.29c-.13-1.09-1.04-1.93-2.16-1.93l-7.42.99c-1.18.03-2.13,1-2.13,2.19v3.38c0,.41.09.81.26,1.19l1.18,2.56c.08.17.12.37.12.56v.34l-.67.08c-.38.04-.67.36-.67.75v3.4c0,.38.28.69.65.74l.69.09v2.91h1.5v-2.7l1.07.14c.64.54,1.46.87,2.37.87s1.72-.34,2.37-.87l1.07-.14v2.71h1.5v-2.91l.69-.09c.37-.05.65-.37.65-.74v-3.4c0-.38-.29-.7-.67-.75l-.66-.07c.03-.33.17-.65.42-.88l1.49-1.38c.69-.64,1.28-1.82.36-5.68h0ZM8.51,15.57c-.13.38-.22.78-.22,1.21s.08.8.21,1.18l-1.26-.17v-2.07l1.27-.14h0ZM12.01,19c-1.22,0-2.22-.99-2.22-2.22s.99-2.22,2.22-2.22,2.22.99,2.22,2.22-.99,2.22-2.22,2.22ZM16.78,15.72v2.07l-1.26.17c.12-.37.21-.76.21-1.17s-.09-.83-.22-1.21l1.27.14ZM17.85,10.88l-1.49,1.38c-.51.47-.82,1.12-.88,1.81l-1.1-.12c-.64-.54-1.46-.87-2.36-.87s-1.72.33-2.36.87l-1.07.12v-.17c0-.41-.09-.82-.26-1.19l-1.18-2.56c-.08-.18-.12-.37-.12-.56v-3.38c0-.38.31-.69.69-.69l7.4-.99c.36.02.65.32.65.69v4.16h1.5v-2.91h.27c.12,0,.22.08.25.21.31,1.32.74,3.63.08,4.23l-.02-.03Z" />
      </SvgWrapper>
    );
  }

  if (name === 'arrow-up-circle') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M12,21.75c5.38,0,9.75-4.37,9.75-9.75S17.38,2.25,12,2.25,2.25,6.62,2.25,12s4.37,9.75,9.75,9.75ZM12,3.75c4.55,0,8.25,3.7,8.25,8.25s-3.7,8.25-8.25,8.25S3.75,16.55,3.75,12,7.45,3.75,12,3.75ZM11.25,9.31v7.19h1.5v-7.19l2.72,2.72,1.06-1.06-4-4c-.15-.15-.34-.22-.53-.22s-.38.07-.53.22l-4,4,1.06,1.06,2.72-2.72Z" />
      </SvgWrapper>
    );
  }

  if (name === 'cert-on-inverted') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M22.36,13.01l-1.05-1.28c-.35-.43-.46-1.19-.24-1.69l.65-1.53c.22-.51-.04-1.06-.56-1.23l-1.58-.51c-.52-.17-1.03-.75-1.12-1.29l-.28-1.64c-.09-.54-.6-.87-1.13-.73l-1.61.43c-.53.14-1.27-.08-1.64-.48l-1.12-1.23c-.37-.41-.98-.41-1.35,0l-1.12,1.23c-.37.41-1.11.62-1.64.48l-1.61-.43c-.53-.14-1.04.19-1.13.73l-.28,1.64c-.09.54-.6,1.12-1.12,1.29l-1.58.51c-.52.17-.78.72-.56,1.23l.65,1.53c.22.51.11,1.27-.24,1.69l-1.05,1.28c-.35.43-.26,1.03.19,1.34l1.37.93c.45.31.77,1.01.71,1.56l-.19,1.65c-.06.55.33,1,.88,1.02l1.66.04c.55.01,1.2.43,1.44.92l.73,1.49c.24.49.82.67,1.29.38l1.42-.86c.47-.29,1.24-.29,1.71,0l1.42.86c.47.29,1.05.11,1.29-.38l.73-1.49c.24-.49.89-.91,1.44-.92l1.66-.04c.55-.01.95-.47.88-1.02l-.19-1.65c-.06-.55.26-1.25.71-1.56l1.37-.93c.45-.31.54-.91.19-1.34ZM9.82,14.69c.6.68,1.37,1.02,2.31,1.02.58,0,1.1-.13,1.56-.4.46-.28.85-.67,1.19-1.19l1.35,1.33c-.5.64-1.11,1.14-1.83,1.5-.72.35-1.51.52-2.37.52-1.03,0-1.94-.24-2.74-.71-.79-.47-1.41-1.12-1.87-1.93-.44-.83-.67-1.78-.67-2.85s.22-2.03.67-2.85c.46-.83,1.09-1.48,1.89-1.95.8-.47,1.72-.71,2.74-.71,1.77,0,3.17.67,4.2,2.02l-1.39,1.33c-.62-1.04-1.55-1.56-2.77-1.56-.93,0-1.69.34-2.29,1.02-.58.67-.87,1.57-.87,2.7s.3,2.01.89,2.7h0Z" />
      </SvgWrapper>
    );
  }

  if (name === 'chevron-right') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M8.47,20.62c-.38,0-.77-.15-1.06-.44-.59-.59-.59-1.54,0-2.12l5.94-5.94-5.94-5.94c-.59-.59-.59-1.54,0-2.12.59-.59,1.54-.59,2.12,0l7,7c.59.59.59,1.54,0,2.12l-7,7c-.29.29-.68.44-1.06.44Z" />
      </SvgWrapper>
    );
  }

  if (name === 'checkmark') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M9.09,20.33l-5.84-5.57c-.6-.57-.62-1.52-.05-2.12.57-.6,1.52-.62,2.12-.05l3.6,3.43,9.69-10.85c.55-.62,1.5-.67,2.12-.12.62.55.67,1.5.12,2.12l-11.75,13.15Z" />
      </SvgWrapper>
    );
  }

  if (name === 'chrono24') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M8.85,3.26c-.35.69-.6,1.28-.56,1.31.04.03.45-.11.91-.32,1.23-.56,1.74-.67,3.28-.67,1.6,0,2.3.13,3.42.67.47.23.82.34.87.28.05-.06-.17-.59-.55-1.32l-.63-1.22h-3.05s-3.05,0-3.05,0l-.64,1.25ZM11.7,6.06c-1.5.15-2.79.84-3.74,2-2.06,2.51-1.75,6.72.64,8.68,1.53,1.25,3.91,1.65,5.97,1,.79-.25,2.15-1.04,2.62-1.52l.3-.31-.57-.83-.56-.83-.24.21c-.52.46-1.76,1.09-2.43,1.25-2.6.61-4.72-.8-4.93-3.28-.16-1.84.71-3.4,2.23-4,.52-.21.81-.25,1.7-.24,1.24.01,2.08.24,3.06.85l.63.39.56-.83c.65-.96.67-.86-.38-1.52-.79-.49-2-.91-2.83-.98-.37-.03-.79-.07-.94-.09-.15-.02-.64,0-1.09.05ZM8.33,19.48c-.06.13-.09.05.61,1.45l.54,1.07,3.08-.03,3.08-.03.62-1.19c.42-.8.58-1.21.51-1.27-.06-.04-.43.08-.83.28-1.13.56-2.14.74-3.8.67-1.46-.06-2.47-.32-3.32-.85-.4-.25-.41-.25-.49-.11Z" />
      </SvgWrapper>
    );
  }

  if (name === 'globe') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M12,22.18c-1.38,0-2.68-.26-3.9-.79-1.22-.52-2.28-1.24-3.18-2.14-.9-.9-1.61-1.96-2.14-3.17-.52-1.22-.79-2.52-.79-3.9s.26-2.68.79-3.9c.53-1.22,1.24-2.27,2.14-3.17.9-.9,1.96-1.61,3.18-2.14,1.22-.52,2.52-.79,3.9-.79s2.68.26,3.9.79c1.22.53,2.27,1.24,3.18,2.14.9.9,1.61,1.96,2.14,3.17.52,1.22.79,2.52.79,3.9s-.26,2.68-.79,3.9c-.52,1.22-1.24,2.27-2.14,3.17s-1.96,1.61-3.18,2.14-2.52.79-3.9.79ZM12,20.18c2.23,0,4.12-.77,5.67-2.33,1.55-1.55,2.33-3.44,2.33-5.67,0-.12,0-.24-.01-.36,0-.12-.01-.23-.01-.31-.08.48-.31.88-.68,1.2-.37.32-.8.48-1.3.48h-2c-.55,0-1.02-.2-1.41-.59-.39-.39-.59-.86-.59-1.41v-1h-4v-2c0-.55.2-1.02.59-1.41.39-.39.86-.59,1.41-.59h1c0-.38.1-.72.31-1.01s.46-.53.76-.71c-.33-.08-.67-.15-1.01-.2-.34-.05-.7-.08-1.06-.08-2.23,0-4.12.78-5.68,2.33-1.55,1.55-2.32,3.44-2.32,5.68h5c1.1,0,2.04.39,2.82,1.17.78.78,1.18,1.73,1.18,2.83v1h-3v2.75c.33.08.66.15.99.19.32.04.66.06,1.01.06Z" />
      </SvgWrapper>
    );
  }

  if (name === 'legal') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M21.28,13.11l-1.24-1.24.53-.53-1.06-1.06-.53.53-5.3-5.3.53-.53-1.06-1.06-.53.53-1.24-1.24c-.68-.68-1.79-.68-2.47,0l-4.59,4.59c-.68.68-.68,1.79,0,2.47l1.24,1.24-.53.53,1.06,1.06.53-.53,5.3,5.3-.54.54,1.06,1.06.54-.54,1.24,1.24c.34.34.79.51,1.24.51s.9-.17,1.24-.51l4.59-4.59c.68-.68.68-1.79,0-2.47h-.01ZM5.37,9.22c-.1-.1-.1-.26,0-.35l4.59-4.59s.11-.07.18-.07.13.02.18.07l1.24,1.24-4.95,4.95-1.24-1.24h0ZM7.67,11.52l4.95-4.95,5.3,5.3-4.95,4.95-5.3-5.3ZM20.22,14.53l-4.59,4.59c-.1.1-.26.1-.35,0l-1.24-1.24,4.95-4.95,1.24,1.24c.1.1.1.26,0,.35h-.01ZM2.19,21.24l1.06,1.06,5.5-5.5-1.06-1.06-5.5,5.5Z" />
      </SvgWrapper>
    );
  }

  if (name === 'lightbulb') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M9,19.75h6v-1.5h-6v1.5ZM10,22.25h4v-1.5h-4v1.5ZM15.31,7.43c-1.23-1-2.85-1.39-4.43-1.06-1.99.41-3.61,2.03-4.02,4.03-.32,1.54.05,3.13,1.01,4.34.17.22.38.57.38.99v.49c0,.5.4.9.9.9h5.7c.5,0,.9-.4.9-.9v-.49c0-.43.2-.77.38-.99.73-.93,1.12-2.05,1.12-3.24,0-1.59-.71-3.07-1.94-4.07ZM14.95,13.81c-.43.55-.67,1.17-.7,1.81h-4.5c-.02-.64-.26-1.26-.7-1.81-.7-.88-.95-1.99-.72-3.11.29-1.42,1.44-2.57,2.85-2.87,1.14-.24,2.3.04,3.18.75.88.72,1.39,1.78,1.39,2.91,0,.85-.28,1.65-.8,2.31h0ZM19,10.49v1.5h3v-1.5h-3ZM18.54,3.64l-2.12,2.12,1.06,1.06,2.12-2.12-1.06-1.06ZM12.75,1.24h-1.5v3h1.5V1.25h0ZM5.46,3.64l-1.06,1.06,2.12,2.12,1.06-1.06-2.12-2.12ZM2,11.99h3v-1.5h-3v1.5Z" />
      </SvgWrapper>
    );
  }

  if (name === 'mobile') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M16.95,1.23H6.95c-.96,0-1.75.79-1.75,1.75v18c0,.96.79,1.75,1.75,1.75h10c.96,0,1.75-.79,1.75-1.75V2.98c0-.96-.79-1.75-1.75-1.75ZM17.2,20.98c0,.14-.11.25-.25.25H6.95c-.14,0-.25-.11-.25-.25V2.98c0-.14.11-.25.25-.25h10c.14,0,.25.11.25.25v18ZM10.5,6.23h3v-1.5h-3v1.5Z" />
      </SvgWrapper>
    );
  }

  if (name === 'money') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M21,9.25H3c-.41,0-.75.34-.75.75v11.5c0,.41.34.75.75.75h18c.41,0,.75-.34.75-.75v-11.5c0-.41-.34-.75-.75-.75ZM3.75,10.75h2.45c-.29,1.21-1.24,2.16-2.45,2.44v-2.44ZM3.75,20.75v-2.44c1.21.28,2.17,1.23,2.45,2.44h-2.45ZM20.25,20.75h-2.47c.29-1.22,1.25-2.17,2.47-2.44v2.44ZM20.25,16.8c-2.05.31-3.66,1.91-3.99,3.95H7.72c-.32-2.04-1.93-3.64-3.97-3.95v-2.1c2.04-.32,3.65-1.91,3.97-3.95h8.54c.33,2.04,1.94,3.65,3.99,3.95v2.09h0ZM20.25,13.2c-1.22-.27-2.18-1.23-2.47-2.44h2.47v2.44ZM12,12.51c-1.79,0-3.25,1.46-3.25,3.25s1.46,3.25,3.25,3.25,3.25-1.46,3.25-3.25-1.46-3.25-3.25-3.25ZM12,17.51c-.96,0-1.75-.79-1.75-1.75s.79-1.75,1.75-1.75,1.75.79,1.75,1.75-.79,1.75-1.75,1.75ZM19,5.76H5v1.5h14v-1.5ZM15.99,2.26h-7.98v1.5h7.98v-1.5Z" />
      </SvgWrapper>
    );
  }

  if (name === 'growth') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M3.83,2.62h-1.5v18.75h18.75v-1.5H3.83V2.62ZM12.23,10.65l3.5,2.46,5.94-7.52-1.18-.93-5.06,6.4-3.5-2.46-5.94,7.56,1.18.93,5.06-6.44Z" />
      </SvgWrapper>
    );
  }

  if (name === 'parcel') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M6.95,8.5H2v1.5h4.95v-1.5ZM5.45,11.5h-3.45v1.5h3.45v-1.5ZM19.39,6.88c-.31-.55-.89-.88-1.52-.88h-2.17v-.25c0-.96-.79-1.75-1.75-1.75H4.45c-.96,0-1.75.79-1.75,1.75v1h1.5v-1c0-.14.11-.25.25-.25h9.5c.14,0,.25.11.25.25v5.5c0,.69.56,1.25,1.25,1.25h5.25v3.75c0,.14-.11.25-.25.25h-1.37c-.33-1.15-1.38-2-2.63-2s-2.3.85-2.63,2h-5.73c-.33-1.15-1.38-2-2.63-2-1.52,0-2.75,1.23-2.75,2.75s1.23,2.75,2.75,2.75c1.25,0,2.3-.85,2.63-2h5.73c.33,1.15,1.38,2,2.63,2s2.3-.85,2.63-2h1.37c.96,0,1.75-.79,1.75-1.75v-4.71l-2.81-4.66ZM15.7,11v-3.5h2.17c.09,0,.17.05.23.14l2.03,3.36h-4.43ZM5.45,18.5c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25,1.25.56,1.25,1.25-.56,1.25-1.25,1.25ZM16.45,18.5c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25,1.25.56,1.25,1.25-.56,1.25-1.25,1.25Z" />
      </SvgWrapper>
    );
  }

  if (name === 'person-pin') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M12,11.18c-1.33,0-4,.67-4,2v.16c.97,1.12,2.4,1.84,4,1.84s3.03-.72,4-1.84v-.16c0-1.33-2.67-2-4-2ZM12,10.18c1.1,0,2-.9,2-2s-.9-2-2-2-2,.9-2,2,.9,2,2,2ZM12,2.18c4.2,0,8,3.22,8,8.2,0,3.32-2.67,7.25-8,11.8-5.33-4.55-8-8.48-8-11.8,0-4.98,3.8-8.2,8-8.2Z" />
      </SvgWrapper>
    );
  }

  if (name === 'protection') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M19.81,3.65l-7.5-1.88c-.2-.05-.41-.05-.61,0l-7.5,1.88c-.56.14-.95.64-.95,1.21v6.61c0,7.96,8.44,10.69,8.53,10.72l.22.07.22-.07c.09-.03,8.53-2.76,8.53-10.72v-6.61c0-.58-.39-1.07-.95-1.21h.01ZM19.26,11.47c0,6.25-5.97,8.75-7.25,9.21-1.24-.46-7.25-3.01-7.25-9.21v-6.41l7.25-1.81,7.25,1.81v6.41ZM8.58,10.5l-1.13,1.13,3.2,3.2c.16.16.36.23.57.23s.41-.08.57-.23l4.8-4.8-1.13-1.13-4.23,4.23-2.63-2.63h-.02Z" />
      </SvgWrapper>
    );
  }

  if (name === 'recurring-arrow') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M12.73,2.53c-3.83,0-7.22,2.34-8.7,5.72l-.84-2.27-1.41.52,1.65,4.44c.12.35.47.76,1.07.39l4.14-2.31-.73-1.31-2.63,1.47c1.16-3.03,4.11-5.16,7.46-5.16,4.4,0,7.98,3.58,7.98,7.98s-3.58,7.98-7.98,7.98v1.5c5.23,0,9.48-4.25,9.48-9.48S17.96,2.53,12.73,2.53Z" />
      </SvgWrapper>
    );
  }

  if (name === 'smiley') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M12,2.27C6.62,2.27,2.25,6.65,2.25,12.02s4.37,9.75,9.75,9.75,9.75-4.37,9.75-9.75S17.38,2.27,12,2.27ZM12,20.27c-4.55,0-8.25-3.7-8.25-8.25S7.45,3.77,12,3.77s8.25,3.7,8.25,8.25-3.7,8.25-8.25,8.25ZM12,16.27c-1.79,0-3.25-1.46-3.25-3.25h-1.5c0,2.62,2.13,4.75,4.75,4.75s4.75-2.13,4.75-4.75h-1.5c0,1.79-1.46,3.25-3.25,3.25ZM8,10.5c.55,0,1-.45,1-1s-.45-1-1-1-1,.45-1,1,.45,1,1,1ZM16,8.5c-.55,0-1,.45-1,1s.45,1,1,1,1-.45,1-1-.45-1-1-1Z" />
      </SvgWrapper>
    );
  }

  if (name === 'transparency') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M9,21.18v-5c-1.03-.08-2.05-.2-3.04-.35s-1.98-.37-2.96-.65l.5-2c1.38.38,2.78.65,4.2.79,1.42.14,2.85.21,4.3.21s2.86-.07,4.27-.21c1.42-.14,2.83-.4,4.23-.79l.5,2c-1,.28-2,.5-2.99.65-.99.15-2,.27-3.01.35v5h-6ZM12,13.18c-.57,0-1.04-.19-1.43-.58-.38-.38-.57-.86-.57-1.42s.19-1.02.57-1.41c.38-.39.86-.59,1.43-.59s1.02.2,1.41.59c.39.39.59.86.59,1.41s-.2,1.04-.59,1.42c-.39.38-.86.58-1.41.58ZM4.5,10.18c-.43,0-.79-.14-1.08-.43-.28-.28-.42-.64-.42-1.08s.14-.77.42-1.06c.28-.29.64-.44,1.08-.44s.77.15,1.06.44c.29.29.44.65.44,1.06s-.15.79-.44,1.08c-.29.28-.65.43-1.06.43ZM19.5,10.18c-.43,0-.79-.14-1.08-.43-.28-.28-.42-.64-.42-1.08s.14-.77.42-1.06c.28-.29.64-.44,1.08-.44s.77.15,1.06.44c.29.29.44.65.44,1.06s-.15.79-.44,1.08c-.29.28-.65.43-1.06.43ZM7.25,6.43c-.43,0-.79-.14-1.07-.42s-.43-.64-.43-1.08.14-.77.43-1.06c.28-.29.64-.44,1.07-.44s.77.15,1.06.44c.29.29.44.65.44,1.06s-.15.79-.44,1.08-.65.42-1.06.42ZM16.75,6.43c-.43,0-.79-.14-1.07-.42-.28-.28-.43-.64-.43-1.08s.14-.77.43-1.06c.28-.29.64-.44,1.07-.44s.77.15,1.06.44c.29.29.44.65.44,1.06s-.15.79-.44,1.08-.65.42-1.06.42ZM12,5.18c-.43,0-.79-.14-1.07-.42-.28-.28-.43-.64-.43-1.08s.14-.77.43-1.06c.28-.29.64-.44,1.07-.44s.77.15,1.06.44c.29.29.44.65.44,1.06s-.15.79-.44,1.08-.65.42-1.06.42Z" />
      </SvgWrapper>
    );
  }

  if (name === 'user') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M21.3,19.27c-.42-1.67-1.91-2.84-3.64-2.84H6.34c-1.72,0-3.22,1.17-3.64,2.84l-.43,1.73,1.46.36.43-1.73c.25-1,1.15-1.7,2.18-1.7h11.32c1.03,0,1.93.7,2.18,1.7l.43,1.73,1.46-.36-.43-1.73ZM11.92,14.93c3.17,0,5.75-2.58,5.75-5.75l-.02-1c0-3.17-2.58-5.75-5.75-5.75s-5.75,2.58-5.75,5.76l.02.99c0,3.17,2.58,5.75,5.75,5.75ZM11.9,3.93c2.34,0,4.25,1.91,4.25,4.26l.02.99c0,2.34-1.91,4.24-4.25,4.24s-4.25-1.91-4.25-4.26l-.02-.99c0-2.34,1.91-4.25,4.25-4.25h0Z" />
      </SvgWrapper>
    );
  }

  if (name === 'watch') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M12,4.74c-4,0-7.25,3.25-7.25,7.25s3.25,7.25,7.25,7.25,7.25-3.25,7.25-7.25-3.25-7.25-7.25-7.25ZM12,17.75c-3.17,0-5.75-2.58-5.75-5.75s2.58-5.75,5.75-5.75,5.75,2.58,5.75,5.75-2.58,5.75-5.75,5.75ZM8.66,3.47c.01-.13.12-.23.25-.23h6.19c.13,0,.24.1.25.23l.05.46c.57.24,1.1.54,1.59.88l-.15-1.49c-.09-.9-.84-1.58-1.74-1.58h-6.19c-.9,0-1.65.68-1.74,1.58l-.15,1.49c.5-.35,1.03-.65,1.59-.88l.05-.46ZM15.35,20.53c-.01.13-.12.22-.25.22h-6.19c-.13,0-.24-.1-.25-.22l-.05-.46c-.57-.24-1.1-.54-1.6-.88l.15,1.49c.09.9.84,1.58,1.74,1.58h6.19c.9,0,1.65-.68,1.74-1.58l.15-1.49c-.5.35-1.03.65-1.6.88l-.05.46h.02ZM12.01,10.92l-1.47-1.47-1.06,1.06,2.53,2.53,3.71-3.71-1.06-1.06-2.65,2.65Z" />
      </SvgWrapper>
    );
  }

  if (name === 'watches') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M6.22,4.16c0-.09.08-.15.17-.15h5.69c.09,0,.16.07.17.15l.05.51c.56.23,1.09.51,1.57.86l-.16-1.57c-.02-.2-.08-.39-.16-.56-.28-.53-.84-.89-1.48-.89h-5.69c-.63,0-1.18.35-1.47.88-.09.17-.15.37-.17.57l-.16,1.57c.48-.35,1.02-.62,1.57-.86l.05-.51h.02ZM9.24,10.94l-1.31-1.31-1.06,1.06,2.37,2.37,3.46-3.46-1.06-1.06-2.4,2.4ZM12.25,19.84c0,.09-.08.15-.17.15h-5.69c-.09,0-.16-.07-.17-.15l-.05-.51c-.55-.23-1.09-.51-1.57-.86l.16,1.57c.03.31.14.58.32.81.31.39.78.64,1.32.64h5.69c.63,0,1.18-.35,1.47-.88.09-.18.15-.37.17-.58l.16-1.57c-.48.35-1.02.62-1.57.86l-.05.51h-.02ZM9.24,5.27c-3.71,0-6.73,3.02-6.73,6.73s3.02,6.73,6.73,6.73,6.73-3.02,6.73-6.73-3.02-6.73-6.73-6.73ZM9.24,17.23c-2.88,0-5.23-2.35-5.23-5.23s2.35-5.23,5.23-5.23,5.23,2.35,5.23,5.23-2.35,5.23-5.23,5.23ZM15.03,3.94h2.53c.09,0,.17.07.18.16l.05.5c.57.24,1.1.55,1.6.91l-.15-1.55c-.09-.86-.8-1.51-1.67-1.51h-3.07c.28.4.47.87.52,1.39v.11h0ZM15.17,5.24l.15,1.52s.01,0,.02.02c2.61.32,4.64,2.52,4.64,5.21s-2.03,4.89-4.63,5.21c0,0-.01.02-.02.03l-.15,1.52c3.52-.24,6.31-3.17,6.31-6.75s-2.79-6.51-6.31-6.75h-.01ZM17.75,19.89c0,.09-.08.16-.18.16h-2.53v.12c-.06.52-.25.98-.53,1.38h3.06c.87,0,1.58-.65,1.67-1.51l.16-1.56c-.49.36-1.03.67-1.6.91l-.05.5Z" />
      </SvgWrapper>
    );
  }

  if (name === 'watch-chart') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M12.01,4.75c-4,0-7.25,3.25-7.25,7.25s3.25,7.25,7.25,7.25,7.25-3.25,7.25-7.25-3.25-7.25-7.25-7.25ZM12.01,17.75c-3.17,0-5.75-2.58-5.75-5.75s2.58-5.75,5.75-5.75,5.75,2.58,5.75,5.75-2.58,5.75-5.75,5.75ZM8.67,3.48c.01-.13.12-.23.25-.23h6.19c.13,0,.24.1.25.23l.05.46c.57.24,1.1.54,1.59.88l-.15-1.49c-.09-.9-.84-1.58-1.74-1.58h-6.19c-.9,0-1.65.68-1.74,1.58l-.15,1.49c.5-.35,1.03-.65,1.59-.88l.05-.46ZM15.36,20.53c0,.13-.12.22-.25.22h-6.18c-.13,0-.24-.1-.25-.22l-.05-.46c-.57-.24-1.1-.54-1.6-.88l.15,1.49c.09.9.84,1.58,1.74,1.58h6.19c.9,0,1.65-.68,1.74-1.58l.15-1.49c-.5.35-1.03.65-1.6.88l-.05.46h0ZM13.33,11.13l-3-1-2.7,2.52c.08.56.27,1.08.54,1.55l2.53-2.36,3,1,2.49-2.32c-.18-.49-.44-.94-.77-1.34l-2.09,1.95ZM2.5,17.43l1.02,1.1,1.82-1.69c-.3-.41-.56-.85-.78-1.32l-2.06,1.92h0ZM21.52,5.53l-1.02-1.1-2.29,2.14c.33.38.63.79.89,1.22l2.43-2.27h-.01Z" />
      </SvgWrapper>
    );
  }

  if (name === 'watch-filled') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M20,12c0-2.54-1.19-4.81-3.04-6.27l-.96-5.73h-8l-.95,5.73c-1.86,1.46-3.05,3.72-3.05,6.27s1.19,4.81,3.05,6.27l.95,5.73h8l.96-5.73c1.85-1.46,3.04-3.73,3.04-6.27ZM6,12c0-3.31,2.69-6,6-6s6,2.69,6,6-2.69,6-6,6-6-2.69-6-6Z" />
      </SvgWrapper>
    );
  }

  if (name === 'worldwide') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M12,2.25C6.63,2.25,2.25,6.62,2.25,12s4.37,9.75,9.75,9.75,9.75-4.37,9.75-9.75S17.38,2.25,12,2.25ZM12,19.86c-.74-.7-1.98-1.91-2.7-4.11h5.4c-.72,2.2-1.96,3.41-2.7,4.11ZM8.94,14.25c-.12-.68-.19-1.42-.19-2.25s.07-1.56.19-2.25h6.13c.11.69.19,1.43.19,2.25s-.07,1.57-.19,2.25h-6.13ZM12,3.94c.66.56,1.98,1.91,2.72,4.31h-5.43c.74-2.41,2.06-3.76,2.72-4.31h-.01ZM16.58,9.75h3.35c.2.72.32,1.47.32,2.25s-.12,1.53-.32,2.25h-3.35c.11-.69.17-1.43.17-2.25s-.06-1.55-.17-2.25ZM19.33,8.25h-3.07c-.5-1.87-1.32-3.25-2.09-4.2,2.25.62,4.11,2.16,5.15,4.2h0ZM9.81,4.05c-.76.95-1.58,2.32-2.09,4.2h-3.07c1.04-2.04,2.91-3.58,5.15-4.2h0ZM4.06,9.75h3.35c-.1.7-.17,1.44-.17,2.25s.07,1.56.17,2.25h-3.35c-.2-.72-.32-1.47-.32-2.25s.12-1.53.32-2.25ZM4.65,15.75h3.08c.56,2,1.51,3.35,2.31,4.26-2.35-.57-4.31-2.15-5.39-4.26ZM13.94,20.01c.8-.9,1.75-2.26,2.31-4.26h3.08c-1.08,2.11-3.04,3.69-5.39,4.26Z" />
      </SvgWrapper>
    );
  }

  /* Logo icons */

  if (name === 'facebook') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 9 18"
      >
        <path d="M0,6.23h2.44v-2.44c0-.42.06-.83.17-1.23.13-.43.33-.83.59-1.2.33-.45.78-.8,1.3-1C5.13.11,5.81,0,6.49,0h2.46v3.11h-2.12c-.27,0-.53.08-.77.21-.25.13-.4.4-.38.68v2.23h3.32l-.51,3.21h-2.81v8.56h-3.27v-8.56H0v-3.21Z" />
      </SvgWrapper>
    );
  }

  if (name === 'instagram') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 18 18"
      >
        <path d="M9,1.62c-2.4,0-2.69,0-3.64.06-.57,0-1.13.12-1.66.32-.38.15-.72.38-1,.68-.29.28-.52.62-.67,1-.2.53-.3,1.1-.31,1.67v7.27c0,.57.09,1.14.28,1.68.15.38.38.72.67,1,.28.3.62.53,1,.68.53.19,1.09.29,1.66.3,1,.05,1.24.06,3.64.06s2.69,0,3.64-.06c.57,0,1.13-.1,1.67-.3.78-.3,1.41-.9,1.72-1.68.2-.53.3-1.1.31-1.67,0-1,.05-1.23.05-3.64s0-2.68-.05-3.63c0-.57-.11-1.13-.31-1.67-.3-.77-.92-1.39-1.69-1.69-.54-.19-1.1-.29-1.67-.3-.95-.07-1.24-.08-3.64-.08ZM9,0c2.45,0,2.75,0,3.71.06.75.01,1.49.15,2.19.41,1.2.47,2.16,1.42,2.63,2.63.26.7.4,1.44.41,2.19,0,1,.06,1.26.06,3.71s0,2.75-.06,3.71c-.01.75-.15,1.49-.41,2.19-.47,1.2-1.43,2.16-2.63,2.63-.7.26-1.44.4-2.19.41-1,0-1.26.06-3.71.06s-2.75,0-3.71-.06c-.75-.01-1.49-.15-2.19-.41-1.2-.47-2.16-1.43-2.63-2.63-.26-.7-.4-1.44-.41-2.19C0,11.75,0,11.45,0,9s0-2.75.06-3.71c.01-.74.15-1.48.41-2.18.21-.6.55-1.15,1-1.6.45-.44.99-.78,1.59-1,.7-.25,1.44-.39,2.19-.41C6.25,0,6.55,0,9,0ZM9,4.38c2.55,0,4.62,2.07,4.62,4.62,0,2.55-2.07,4.62-4.62,4.62h0c-2.55,0-4.62-2.07-4.62-4.62s2.07-4.62,4.62-4.62ZM9,12c1.66.03,3.02-1.29,3.05-2.94.03-1.66-1.29-3.02-2.94-3.05-.04,0-.07,0-.11,0-1.66.03-2.97,1.4-2.94,3.05.03,1.61,1.33,2.92,2.94,2.94ZM14.89,4.19c0,.6-.48,1.08-1.08,1.08-.6,0-1.08-.48-1.08-1.08,0-.6.48-1.08,1.08-1.08.6,0,1.08.48,1.08,1.08Z" />
      </SvgWrapper>
    );
  }

  if (name === 'linkedin') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 18 18"
      >
        <path d="M.3,6h3.7v12H.3V6ZM2.2,0c1.2,0,2.2,1,2.2,2.2s-1,2.2-2.2,2.2c-1.2-.1-2.2-1-2.2-2.2S1,0,2.2,0ZM6.4,6h3.6v1.6c.7-1.3,2.1-2,3.5-1.9,3.8,0,4.5,2.5,4.5,5.7v6.6h-3.7v-5.8c0-1.4,0-3.2-1.9-3.2s-2.2,1.5-2.2,3.1v5.9h-3.8V6Z" />
      </SvgWrapper>
    );
  }

  if (name === 'xing') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 15 18"
      >
        <path d="M4.58,4l1.75,3.11c-.07.13-1,1.78-2.75,5-.11.29-.38.48-.69.5H.32c-.13,0-.25-.07-.31-.18-.02-.07-.02-.13,0-.2-.02-.06-.02-.13,0-.19l2.71-4.88-1.72-3c-.08-.12-.08-.29,0-.41.07-.11.21-.17.34-.16h2.55c.29,0,.56.16.7.41ZM14.94.57l-5.63,10.16,3.59,6.69c.08.13.08.28,0,.41-.08.11-.21.17-.34.16h-2.55c-.31,0-.59-.2-.7-.49l-3.62-6.77L11.35.49c.11-.28.38-.47.68-.49h2.58c.13-.02.26.05.33.16.08.12.08.29,0,.41Z" />
      </SvgWrapper>
    );
  }

  if (name === 'youtube') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 18 12"
      >
        <path d="M17.82,2.59c-.09-.62-.34-1.2-.72-1.69-.49-.46-1.13-.72-1.8-.73C12.78,0,9,0,9,0c0,0-3.78,0-6.3.17-.67,0-1.32.27-1.81.73-.38.49-.63,1.07-.71,1.69-.11.92-.17,1.84-.18,2.76v1.29c0,.93.07,1.85.18,2.77.09.62.34,1.2.72,1.69.56.47,1.27.73,2,.73,1.42.17,6.1.17,6.1.17,0,0,3.78,0,6.3-.18.67,0,1.31-.26,1.8-.72.38-.49.63-1.07.72-1.69.11-.92.17-1.84.18-2.77v-1.29c0-.92-.07-1.84-.18-2.76ZM7.14,8.21V3.42l4.86,2.4-4.86,2.39Z" />
      </SvgWrapper>
    );
  }

  /* Custom icons */

  if (name === 'arrow-up-right') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 10 10"
      >
        <polygon points="1.02 10 0 8.97 7.53 1.45 1.47 1.45 1.47 0 10 0 10 8.07 8.55 8.07 8.55 2.47 1.02 10" />
      </SvgWrapper>
    );
  }

  if (name === 'play') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 10 10"
      >
        <path d="M9.09,4.19c.62.37.62,1.24,0,1.62l-5.03,3.05c-.66.4-1.51-.06-1.51-.81V1.95c0-.75.85-1.2,1.51-.81l5.03,3.05Z" />
      </SvgWrapper>
    );
  }

  if (name === 'times') {
    return (
      <SvgWrapper
        className={className}
        viewBox="0 0 24 24"
      >
        <path d="M14.12,12l5.93-5.93c.59-.59.59-1.54,0-2.12-.59-.59-1.54-.59-2.12,0l-5.93,5.93L6.07,3.95c-.59-.59-1.54-.59-2.12,0-.59.59-.59,1.54,0,2.12l5.93,5.93-5.93,5.93c-.59.59-.59,1.54,0,2.12.29.29.68.44,1.06.44s.77-.15,1.06-.44l5.93-5.93,5.93,5.93c.29.29.68.44,1.06.44s.77-.15,1.06-.44c.59-.59.59-1.54,0-2.12l-5.93-5.93Z" />
      </SvgWrapper>
    );
  }
}
